<template>
    <div class="item" @click="$emit('onClick')">
      <div class="images">
        <img :src="images" alt="">
      </div>
      <div class="title">{{title}}</div>
    </div>
</template>

<script>
    export default {
        name: "case-item",
      props: {
          images: {
            type: String,
            default: ''
          },
        title: {
            type: String,
          default: ''
        }
      }
    }
</script>

<style lang="less" scoped>
  .item{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  
    .images{
      height: calc(100% - 91px);
      box-shadow: 0 1px 10px 0 rgba(99,99, 99, .1);
      img{
        width: 100%;
        height: 100%;
      }
    }
    .title{
      height: 91px;
      text-align: center;
     display: flex;
     align-items: center;
     justify-content: center;
      font-size: 16px;
      color: #272727;
    }

    &:hover{
      .title{
        color: #3188EC;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/case-item.vue